import axios from 'axios';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { axiosConfig, ThrowErrorMsg } from '../util';

const basePathV1 = `${process.env.REACT_APP_API_URL}/v1`;

export const getLivePostsGroupCount = (query) => async (dispatch) => {
  try {
    const params = {
      ...query,
    };
    const res = await axios.get(`${basePathV1}/analytics/category/livePosts`, { params }, axiosConfig);
    if (res.status === 200) {
      return res.data;
    } else {
      toast.error(res.data);
      return null;
    }
  } catch (err) {
    ThrowErrorMsg(err);
  }
};
